const cardAmexRegExp = /^37|^34/

export { cardAmexRegExp }
